<template>
    <div class="flex flex-center-vh">
        <div class="flex-1 flex-no-padding">
            <div class="profile-icon-l">
                <img v-if="appear_logged_in.status === true" :src="appear_logged_in.avatar">
                <img v-else src="/img/avatar.png">
            </div>
        </div>
        <div class="flex-16 flex-no-padding comment-content relative"
             style="margin-left: 25px;">

            <a href="/auth/login" v-if="appear_logged_in.status === true">
                <p class="light-text" v-html="translations['auth.no_longer_signed_in']"></p>
            </a>

            <p v-else class="light-text appear-logged-in">
                {{ translations['forum.login_to_comment'] }} <a
                    href="/auth/login#login" class="secondary-c bold-text"> {{
                translations['navigation.login'] }} </a>
                <template
                        v-if="settings.allow_registration && (! settings.hide_registration)">
                    {{ translations['login.other_option'].toLowerCase() }} <a
                        href="/auth/login#register" class="secondary-c bold-text">
                    {{ translations['navigation.register_now'].toLowerCase() }}. </a></template>
            </p>
        </div>
    </div>
</template>

<script>
  import Global from '../../mixins/Global.js'
  import { mapState } from 'vuex';

  export default {
    name: 'LoginToComment',

    mixins: [Global],

    computed: {
      ...mapState([
        'appear_logged_in'
      ]),
    }
  }
</script>